/**
 * Ajoute une classe `parentLink` aux `li` parents et un élément `<span class="niveauEnfant"></span>` aux liens pour
 * les sous-menus.
 */
export const enrichirMenu = () => {
    $('.menuSite li ul').each(function () {
        // On met la classe parentLink sur les li qui contiennent des sous-ul
        $(this).parent('li').addClass('parentLink');
        // On rajoute la petite fleche qui servira pour naviguer dans les niveaux sur mobile
        $(this)
            .parent('li')
            .children('a')
            .append('<span class="niveauEnfant"></span>');
    });
};
/**
 * Ouvre le menu mobile au clic.
 */
export const ouvrirMenu = (menu) => {
    $('.menuSite-bouton').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });
};
/**
 * Ouvre les élements du sous-menu.
 */
export const ouvrirSousMenu = (mobileBreakPoint, animEnCours) => {
    $('.menuSite-interne .niveauEnfant').on('click', function () {
        if (window.innerWidth < mobileBreakPoint) {
            if (
                $(this).closest('li').children('ul').length > 0 &&
                !animEnCours
            ) {
                animEnCours = true;
                $(this)
                    .closest('li')
                    .children('ul')
                    .prepend(
                        '<li class="menuSite-retour"><a href="#" title="Retour au menu précédent">Retour</a></li>'
                    );
                $(this).closest('li').children('ul').css('display', 'block');
                $('.menuSite-interne')
                    .stop(true, true)
                    .animate(
                        {
                            left: '-=100%',
                        },
                        400,
                        function () {
                            animEnCours = false;
                        }
                    );
                return false;
            } else {
                return true;
            }
        }
    });
    return false;
};
/**
 * Gère le clic sur la flèche de retour du menu mobile.
 */
export const retourMenu = (animEnCours) => {
    $('.menuSite ul li').on('click', '.menuSite-retour', function () {
        var retour = $(this);
        if (!animEnCours) {
            animEnCours = true;
            $('.menuSite-interne')
                .stop(true, true)
                .animate(
                    {
                        left: '+=100%',
                    },
                    400,
                    function () {
                        retour.parent('ul').css('display', 'none');
                        retour.remove();
                        animEnCours = false;
                    }
                );
        }
        return false;
    });
    return false;
};
